<template>
    <div class="org_settings" >
        <h2 class="mb-2">Direct Mail Selection <em>(Early Access)</em></h2>
        <div class="row">
            <nav id="org-setting-tab-nav" class="col-12 navbar navbar-expand primary-tab-bar">
                <div class="container-fluid">
                    <div class="collapse navbar-collapse">
                        <ul class="navbar-nav">
                            <li class="nav-item" v-for="tab_name in direct_mail_tabs">
                                <a class="nav-link d-flex flex-nowrap primary-tab" :class="{'primary-tab-active': tab_name == direct_mail_tab_name_active}"
                                href="#" role="button" aria-expanded="false" @click.prevent="setActiveTab(tab_name)">
                                    <span>{{ tab_name.replace('_', ' ') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div>
                <div v-if="direct_mail_tab_name_active == 'File Layouts'">
                    <file-layouts :client="client" :layouts="local_layouts" :data_blend="data_blend"></file-layouts>
                </div>
                <div v-if="direct_mail_tab_name_active == 'Appeals'">
                    <appeals :client="client" :appeals="local_appeals" :file_layouts="local_layouts"></appeals>
                </div>
                <div v-if="direct_mail_tab_name_active == 'Audiences'" class="pathways-manage">
                    <pathways-manage-segments :client="client" :segments="local_segments"  :census_connections="census_connections" 
                        :connection_datasets="connections" :datasets="[]" :datablends="datablends"></pathways-manage-segments>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['user', 'client', 'layouts', 'appeals', 'data_blend', 'segments', 'census_connections', 'connections', 'datablends'],
        data() {
            return {
                local_layouts: [],
                local_appeals: [],
                local_segments: [],
                direct_mail_tabs:['Appeals', 'File Layouts', 'Audiences'],
                direct_mail_tab_name_active: 'File Layouts'
            };
        },
        beforeMount() {
            this.local_layouts = this.layouts;
            this.local_appeals = this.appeals;
            this.local_segments = this.segments;

            let tab_name = window.location.pathname.split('/').pop().toLowerCase();

            // If there are no file layouts, show File Layouts tab first
            // Otherwise, show Appeals tab first
            if (this.local_layouts.length === 0) {
                this.direct_mail_tab_name_active = 'File Layouts';
            } 

            // Override with URL-based tab if specified
            else if (tab_name == 'file_layouts')
                this.direct_mail_tab_name_active = 'File Layouts';
            else if (tab_name == 'appeals')
                this.direct_mail_tab_name_active = 'Appeals';
            else if (tab_name == 'audiences')
                this.direct_mail_tab_name_active = 'Audiences';
        },
        methods: {
            setActiveTab(tab_name){
                this.direct_mail_tab_name_active = tab_name;
                var newURL = '/direct_mail/'+this.client.url+'/' + tab_name.toLowerCase();
                window.history.replaceState({}, {}, newURL);
            }
        }
    }
</script>